<template>
  <form>
    <div class="form-group">
      <select v-model="selectedRaceUuid" class="form-control">
        <option v-for="race in races" :key="race.uuid" :value="race.uuid">
          {{ race.short_name }}
        </option>
      </select>
    </div>
  </form>
</template>

<script>
export default {
  name: "SelectRace",
  props: {
    loaded: {
      type: Boolean,
      default: false,
    },
    races: {
      type: Array,
    },
  },
  computed: {
    selectedRaceUuid: {
      get() {
        return this.$store.state.racesStore.selectedRace?.uuid || null;
      },
      set(uuid) {
        const race = (this.races || []).find((r) => r.uuid === uuid);
        if (race) this.$emit("select-race", race);
      },
    },
  },
};
</script>
